import {isMobile} from '@aoflmkt/is-mobile';
import {apis, environment, outboundLinks} from './constants-enumerate';
import {resourceEnumerate} from './resource-enumerate';

/**
 * Resolves the download destination that matches the visitor's device. Mobile and
 * Chromebook visitors get a store listing, desktop visitors get an installer hosted
 * on the CDN.
 */
class DownloadLinkService {
  /**
   * Returns an empty string when the device cannot be identified.
   *
   * @return {Promise<String>}
   */
  static async getDownloadLink() {
    if (!isMobile.any) {
      if (environment.IS_CHROMEBOOK) {
        return outboundLinks.GOOGLE_PLAY;
      }

      const installerLink = await DownloadLinkService.getInstallerLink();
      return installerLink;
    }

    if (isMobile.apple.device) {
      return outboundLinks.APP_STORE;
    }

    if (isMobile.android.device) {
      return outboundLinks.GOOGLE_PLAY;
    }

    return '';
  }

  /**
   *
   * @return {Promise<String>}
   */
  static async getInstallerLink() {
    const resourceEnumerateResp = await resourceEnumerate.get(apis.MARKETING);
    const apiDomains = resourceEnumerateResp.payload.api_domains;
    const clientVersions = resourceEnumerateResp.payload.client_versions;

    const isMac = navigator.platform.indexOf('MacIntel') !== -1;
    const platform = isMac ? 'mac' : 'windows';
    const extension = isMac ? 'dmg' : 'msi';
    const clientVersion = isMac ? clientVersions.mac : clientVersions.windows;

    return apiDomains.cdn_base_url + '/' + apiDomains.cdn_version + '/Installer/' +
      clientVersion + '/' + platform + '/AdventureAcademy.' + extension;
  }
}

export {
  DownloadLinkService
};
